export function initNewsInsightsSlider() {
    if (typeof Swiper === "undefined") {
      return;
    }
  
    const sections = document.querySelectorAll(".js-news-insights-swiper");
    if (!sections.length) {
      return;
    }
  
    const fewModeMobileQuery = window.matchMedia("(max-width: 600px)");
  
    const controllers = Array.from(sections).map((sectionEl) => {
      const sliderEl = sectionEl.querySelector(".news-insights__list .swiper");
      const btnPrev = sectionEl.querySelector(
        ".news-insights_swiper-nav__prev"
      );
      const btnNext = sectionEl.querySelector(
        ".news-insights_swiper-nav__next"
      );
  
      let swiperInstance = null;
  
      const slideCount = sliderEl
        ? sliderEl.querySelectorAll(".swiper-slide").length
        : 0;
  
      const destroySwiper = () => {
        if (!swiperInstance) {
          return;
        }
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      };
  
      const initManySlidesSwiper = () => {
        if (!sliderEl || swiperInstance) {
          return;
        }
        swiperInstance = new Swiper(sliderEl, {
          slidesPerView: 1,
          spaceBetween: 10,
          watchOverflow: true,
          loop: true,
          centeredSlides: true,
          navigation: {
            prevEl: btnPrev,
            nextEl: btnNext,
          },
          breakpoints: {
            600: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            991: {
              slidesPerView: 3,
              spaceBetween: 24,
              centeredSlides: false,
            },
          },
        });
      };
  
      const initFewSlidesMobileSwiper = () => {
        if (!sliderEl || swiperInstance) {
          return;
        }
        const maxPair = Math.min(2, slideCount);
        swiperInstance = new Swiper(sliderEl, {
          slidesPerView: 1,
          spaceBetween: 10,
          watchOverflow: true,
          loop: true,
          centeredSlides: true,
          navigation: {
            prevEl: btnPrev,
            nextEl: btnNext,
          },
          breakpoints: {
            600: {
              slidesPerView: maxPair,
              spaceBetween: 24,
              centeredSlides: false,
            },
          },
        });
      };
  
      const sync = () => {
        if (!sliderEl) {
          return;
        }
  
        if (slideCount <= 1) {
          destroySwiper();
          return;
        }
  
        if (slideCount > 3) {
          if (!swiperInstance) {
            initManySlidesSwiper();
          }
          return;
        }
  
        if (fewModeMobileQuery.matches) {
          if (!swiperInstance) {
            initFewSlidesMobileSwiper();
          }
        } else {
          destroySwiper();
        }
      };
  
      sync();
  
      return { sync };
    });
  
    const onFewModeViewportChange = () => {
      controllers.forEach((c) => c.sync());
    };
  
    if (typeof fewModeMobileQuery.addEventListener === "function") {
      fewModeMobileQuery.addEventListener("change", onFewModeViewportChange);
    } else {
      fewModeMobileQuery.addListener(onFewModeViewportChange);
    }
  }
  